import React, { memo } from 'react';
import classnames from 'classnames';

import { TextField } from '../../../material-ui/TextField';
import { useTotalPanelField } from './useTotalPanelField';
import { useStyles } from './useStyles';

export const Disable = {
    FALSE: 0,
    TRUE: 1,
    RELATIVE: 2,
};

export const InputStyle = {
    NONE: 0,
    SIMPLE: 1,
    SPECIAL: 2,
    INVISIBLE: 3,
};

export const TotalPanelField = memo((props) => {
    const classes = useStyles();

    const {
        name,
        onEdit,
        style,
        value1,
        value2,
        isTotalEditable,
        disable,
        required = true,
        validator,
        defaultValue,
        helperText,
        label,
        onFocus,
        ...restProps
    } = props;

    const isDisable = disable === Disable.TRUE || (disable === Disable.RELATIVE && !isTotalEditable);

    const { customHelperText, fieldStyle, errorText, placeholder, value, handleEdit, handleChange, handleInputFocus } = useTotalPanelField(
        name,
        onEdit,
        onFocus,
        label,
        style,
        value1,
        value2,
        isTotalEditable,
        isDisable,
        required,
        validator,
        defaultValue,
        helperText
    );

    const className = classnames(classes.field, style === InputStyle.INVISIBLE ? classes.hidden : '');

    const InputLabelProps = React.useMemo(
        () => ({
            shrink: true,
            className: classes.label,
            ...props.InputLabelProps,
        }),
        []
    );

    return (
        <TextField
            key={name}
            {...restProps}
            {...{ className, placeholder, name, InputLabelProps }}
            label={label}
            value={value}
            disabled={isDisable}
            helperText={customHelperText}
            error={Boolean(errorText)}
            margin="normal"
            onBlur={handleEdit}
            onChange={handleChange}
            onFocus={handleInputFocus}
            inputProps={{ className: fieldStyle }}
            FormHelperTextProps={{
                className: classes.helperText,
            }}
        />
    );
});

TotalPanelField.displayName = 'TotalPanelField';
